import { Avatar, type AvatarProps } from "@/components/ui/avatar.tsx";
import { cn } from "cn";
import { getInitials } from "./getInitials.ts";
import type { DisplayPerson } from "./personTypes.ts";
import { PlaceholderAvatar, type PlaceholderAvatarProps } from "./PlaceholderAvatar.tsx";

export interface PersonAvatarProps {
    person?: DisplayPerson;
    size?: AvatarProps["size"];
    className?: string;
    alt?: string;
    placeholderIcon?: PlaceholderAvatarProps["icon"];
    isSquare?: boolean;
}

export function PersonAvatar({ person, size, className, alt = "", isSquare, placeholderIcon }: PersonAvatarProps) {
    if (!person || person.isDeleted) {
        return <PlaceholderAvatar size={size} className={className} icon={placeholderIcon} />;
    }

    return <Avatar size={size} src={person.imageUrl} initials={getInitials(person.displayName ?? "")} alt={alt} isSquare={isSquare} className={cn("bg-secondary text-muted-fg", className)} data-private />;
}
